/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 09:25:30
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-25 15:14:01
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\Work\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
function Work() {
  const { t } = useTranslation();
  const workCenter = t("solution_archives.archives1", { returnObjects: true });
  const changeDetail = (type, index) => {
    let ele = document.getElementsByClassName("work_detail")[index];
    if (type) {
      ele.style.height = "150px";
    } else {
      ele.style.height = "0";
    }
  };
  return (
    <div className="work_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{workCenter.til}</div>
          <span>&nbsp;</span>
        </div>
      </div>
      <div className="work_con">
        <ul className="work_sides">
          {workCenter.contentLeftList.map((item, index) => {
            return (
              <li key={index}>
                <div className="work_detail">
                  <div className="work_detail_title">{item.title}</div>
                  <div className="work_detail_con">
                    {item.conList.map((item1, index1) => {
                      return <div key={index1}>{item1}</div>;
                    })}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
        <div className="work_img">
          <img src={workCenter.imgUrl} alt="" />
        </div>
        <ul className="work_sides">
          {workCenter.contentRightList.map((item, index) => {
            return (
              <li key={index}>
                <div className="work_detail">
                  <div className="work_detail_title">{item.title}</div>
                  <div className="work_detail_con">
                    {item.conList.map((item1, index1) => {
                      return <div key={index1}>{item1}</div>;
                    })}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default Work;
